class PimosferMobileHeroSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-slider-track]');
    this.slides = [...this.querySelectorAll('[data-slide]')];
    this.dots = [...this.querySelectorAll('[data-slide-dot]')];
    if (!this.track || this.slides.length < 2) return;

    this.currentIndex = 0;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.autoplayDisabled = this.hasAttribute('data-autoplay-disabled');
    this.delay = Number(this.dataset.autoplaySeconds || 5) * 1000;
    this.scrollTimer = 0;

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        this.goTo(index);
        this.restartAutoplay();
      });
    });

    this.track.addEventListener('scroll', () => {
      window.clearTimeout(this.scrollTimer);
      this.scrollTimer = window.setTimeout(() => this.syncIndex(), 80);
    }, { passive: true });

    this.track.addEventListener('pointerdown', () => this.stopAutoplay(), { passive: true });
    this.track.addEventListener('pointerup', () => this.startAutoplay(), { passive: true });
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    this.startAutoplay();
  }

  disconnectedCallback() {
    this.stopAutoplay();
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  }

  handleVisibilityChange = () => {
    if (document.hidden) this.stopAutoplay();
    else this.startAutoplay();
  };

  goTo(index) {
    this.currentIndex = (index + this.slides.length) % this.slides.length;
    this.track.scrollTo({ left: this.currentIndex * this.track.clientWidth, behavior: 'smooth' });
    this.updateDots();
  }

  syncIndex() {
    const nextIndex = Math.round(this.track.scrollLeft / this.track.clientWidth);
    if (nextIndex === this.currentIndex) return;
    this.currentIndex = nextIndex;
    this.updateDots();
    this.restartAutoplay();
  }

  updateDots() {
    this.dots.forEach((dot, index) => {
      if (index === this.currentIndex) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  }

  startAutoplay() {
    if (this.reducedMotion || this.autoplayDisabled || document.hidden) return;
    this.stopAutoplay();
    this.autoplayTimer = window.setInterval(() => this.goTo(this.currentIndex + 1), this.delay);
  }

  stopAutoplay() {
    window.clearInterval(this.autoplayTimer);
  }

  restartAutoplay() {
    this.stopAutoplay();
    this.startAutoplay();
  }
}

if (!customElements.get('pimosfer-mobile-hero-slider')) {
  customElements.define('pimosfer-mobile-hero-slider', PimosferMobileHeroSlider);
}
